import reducer from './reducer';

const addModule = {
  reducer,
};
export default addModule;
